export const dateConverter = (dateString) => {
    let a = new Date(dateString);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let year = a.getFullYear();
    let month = months[a.getMonth()];
    let date = a.getDate();
    let res = date + ' ' + month + ' ' + year;
    return res;
}